import { Injectable } from "@angular/core";
import { TicketClientService } from "@app2/clients/ticket-client.service";
import { NotificationsService } from "@app2/shared/services/notifications.service";
import { TicketTemplate } from "@app2/type-defs/ticket/ticket-types";
import { Observable, ReplaySubject, Subject } from "rxjs";
import { throttleTime } from "rxjs/operators";
import { getMessageForError } from "@app2/util/errors/handleable-errors";

@Injectable({
    providedIn: "root",
})
export class TicketTemplateService {
    private templates$ = new ReplaySubject<TicketTemplate[]>(1);

    private requestReload = new Subject<void>();

    constructor(private readonly ticketService: TicketClientService,
                private readonly notificationsService: NotificationsService) {
        this.reloadTemplates();

        this.requestReload
            .pipe(throttleTime(1000),)
            .subscribe(() => this.reloadTemplates());
    }

    public getTemplates$(reload = false): Observable<TicketTemplate[]> {
        if (reload) {
            this.requestReload.next();
        }
        return this.templates$.asObservable();
    }

    reloadTemplates(): void {
        this.ticketService.getTemplates()
            .then((templates: TicketTemplate[]) => {
                this.templates$.next(templates);
            })
            .catch(error => {
                const message = getMessageForError(error.error, "TICKET_DESCRIPTION_TEMPLATE_LOADING_ERROR");
                this.notificationsService.showError(message, error);
            });
    }
}
